(function () {
  var STORAGE_KEY = "incapima-lang";

  function getStoredLang() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function storeLang(lang) {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) {}
  }

  function applyLanguage(lang) {
    document.documentElement.lang = lang;
    document.querySelectorAll("[data-lang]").forEach(function (el) {
      el.classList.toggle("is-hidden", el.getAttribute("data-lang") !== lang);
    });
    document.querySelectorAll(".lang-toggle").forEach(function (btn) {
      btn.textContent = lang === "es" ? "EN" : "ES";
    });
    var body = document.body;
    var titleAttr = lang === "es" ? "data-title-es" : "data-title-en";
    if (body && body.hasAttribute(titleAttr)) {
      document.title = body.getAttribute(titleAttr);
    }
  }

  function setLanguage(lang) {
    window.Site.lang = lang;
    storeLang(lang);
    applyLanguage(lang);
  }

  window.Site = {
    lang: getStoredLang() || "es",
    setLanguage: setLanguage,
    applyLanguage: applyLanguage,
    toggleLanguage: function () {
      setLanguage(window.Site.lang === "es" ? "en" : "es");
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    applyLanguage(window.Site.lang);
  });
})();
